export const ENDPOINT = {
    SETTINGS: 'settings',
    SAVE_VOTE: 'savevote',
    GET_VOTE: 'getvote',
    SEND_EMAIL: 'sendmail',
    UPLOAD_IMAGE: 'uploadimage'
}